import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  GET_USER,
  RECORD_PATIENT_SUMMARY_DISMISSAL,
  type RecordPatientSummaryDismissalRequest,
  type RecordPatientSummaryDismissalResponse,
  type UserResponse,
} from '../../contracts';
import { recordPatientSummaryTurnOffPromptDismissal } from '../api/user';

interface UseMutateRecordPatientSummaryDismissalOptions {
  onSuccess?: (data: RecordPatientSummaryDismissalResponse) => void;
  onError?: (error: Error) => void;
}

export function useMutateRecordPatientSummaryDismissal(
  options?: UseMutateRecordPatientSummaryDismissalOptions
) {
  const queryClient = useQueryClient();

  return useMutation<
    RecordPatientSummaryDismissalResponse,
    Error,
    RecordPatientSummaryDismissalRequest
  >({
    mutationKey: [RECORD_PATIENT_SUMMARY_DISMISSAL],
    mutationFn: async (input) => {
      const { data } = await recordPatientSummaryTurnOffPromptDismissal(input);
      return data;
    },
    onSuccess: (data) => {
      queryClient.setQueryData([GET_USER], (old: UserResponse | undefined) =>
        old
          ? {
              ...old,
              patient_summary_turn_off_prompt: data.patient_summary_turn_off_prompt,
            }
          : old
      );
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
}
